const state = () => ({
    definitionId:'', // 任务流程名称即：process_xxx:10:xxxx
    deployId:'', // 任务id
    taskName:[], //流程节点信息
    detail:[], // 每条请假信息的详细数据
    isApprove: 0,
    totalWorkOffHours:'', // 每月可调休的总时长
    totalForLeaveHours:'', // 每次请假的时长
    yearRemainDays:'', // 剩余的年假时长
})
const getters = {}
const mutations = {
    setDefinitionId(state,value){
        state.definitionId = value
    },
    setDeployId(state,value){
        state.deployId = value
    },
    setTaskName(state,value){
        state.taskName = value
    },
    setDetail(state,value){
        state.detail = value
    },
    setIsApprove(state,value){
        state.isApprove = value
    },
    setTotalWorkOffHours(state,value){
        state.totalWorkOffHours = value
    },
    setTotalForLeaveHours(state,value){
        state.totalForLeaveHours = value
    },
    setYearRemainDays(state,value){
        state.yearRemainDays = value
    }
}
export default {
    namespaced: true,
    state,
    getters,
    mutations
}
